export const BLIDPattern = /^BL-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/;

export const validateBlid = (blid: string): boolean => {
  return BLIDPattern.test(blid);
};
